import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import {
  getRecover
} from "api/users";
import Card from "components/card";
import DivLoader from "components/divloader/DivLoader";
import InputField from "components/fields/InputField";
import React from "react";
import { toast } from "react-hot-toast";
const Recover = ({
  setModel2FA,
  setData,
  loginData
}: {
  status?: any;
  data?: any;
  fetch2fa?: () => void;
  profileData?: any;
  fetchProfile?: () => void;
  setModel2FA?: any;
  setData?: any;
  loginData?:any
}) => {
  const verifyData = loginData;
  const rootForm = {
    recover_key: "",
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [formValues, setFormValues] = React.useState<any>(rootForm);
  const [formValuesErr, setFormValuesErr] = React.useState<any>(rootForm);
  const handleClose = () => {
    setFormValues(rootForm);
    setFormValuesErr(rootForm);
    onClose();
  };
  function handleValueChange(e: any) {
    setFormValues((preVal: any) => {
      return { ...preVal, [e.target.id]: e.target.value };
    });
    setFormValuesErr((preVal: any) => {
      return { ...preVal, [e.target.id]: "" };
    });
  }

  function validateData() {
    if (formValues.recover_key.length < 6) {
      setFormValuesErr((preval: any) => {
        return {
          ...preval,
          recover_key: "Recover key must be required",
        };
      });
      return false;
    }
    return true;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();
    let validate = validateData();
    if (validate) {
      try {
        setIsLoading(true);
        await getRecover({
          recover_key: formValues?.recover_key?.trim(),
          user_id: verifyData?.user_id,
        })
          .then((data) => {
            handleClose();
            setModel2FA(formValues?.recover_key);
            setData(data)
            toast.success(data?.message ?? "Recover key verified successfully");
          })
          .catch((err) => {
            toast.error(
              err?.response?.data?.message ??
                "Something went wrong while fetching Recover"
            );
          })
          .finally(() => {
          });
        
      } catch (err: any) {
        if (err?.response?.status === 422) {
          toast.error("Please provide valid values");
        } else {
          toast.error(err?.response?.data?.message ?? "Unable save user data");
        }
      } finally {
        setIsLoading(false);
      }
    }
  }
  const handelEnter = (event: any) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode === 13) {
      handleSubmit(event);
    }
  };

  return (
    <>
      <p
        onClick={() => {
          onOpen();
        }}
        className=" cursor-pointer  font-medium text-brand-500 hover:text-brand-600 dark:text-white"
      >
        Recover Authentication
      </p>
      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        {/* <ModalContent className="top-[12vh] !z-[1002] !m-auto !w-max min-w-[400px] !max-w-[85%] max-w-[600px] lg:min-w-[400px]"> */}
        <ModalContent className="top-[6vh] !z-[1002] !m-auto !w-max min-w-[480px] !max-w-[95%] lg:min-w-[520px]">
          <ModalBody style={{ padding: 0 }}>
            <div className="tfa-modal">
              <div className="tfa-modal-header">
                <div className="tfa-modal-header-left">
                  <div className="tfa-header-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                  </div>
                  <div>
                    <h1 className="tfa-modal-title">Recover Authentication</h1>
                    {/*  */}
                  </div>
                </div>
                <button className="tfa-close-btn" onClick={handleClose} aria-label="Close">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
              <div className="tfa-modal-body">
                <div className="tfa-section tfa-section--last">
                  <div className="tfa-section-header">
                    <h2 className="tfa-section-title">Recover Key</h2>
                  </div>
                  <p className="tfa-verify-hint">Must provide it when you want to reset your 2FA</p>
                  <div className="si-field">
                    <div className="si-inp-wrap">
                      <span className="si-inp-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                        </svg>
                      </span>
                      <input
                        id="recover_key"
                        type="text"
                        placeholder="recover key"
                        value={formValues?.recover_key}
                        onChange={handleValueChange}
                        className={`si-inp${formValuesErr?.recover_key ? " si-inp--err" : ""}`}
                      />
                    </div>
                    {formValuesErr?.recover_key && (
                      <p className="si-err-msg">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                        {formValuesErr?.recover_key}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="tfa-modal-footer">
                <div className="tfa-security-note">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                  2FA adds a critical extra layer of security
                </div>
                <div className="tfa-footer-btns">
                  <button onClick={handleClose} className="tfa-btn-cancel">Cancel</button>
                  <button onClick={handleSubmit} className="tfa-btn-verify" disabled={isLoading}>
                    {isLoading ? (
                      <span className="tfa-spinner" />
                    ) : (
                      <>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        Verify
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div> 
          </ModalBody>
        </ModalContent>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        si-field { display: flex; flex-direction: column; gap: 6px; }
        .si-lbl-row { display: flex; justify-content: space-between; align-items: center; }
        .si-lbl {
          font-size: 13px;
          font-weight: 600;
          color: #374151;
        }

        /* ── Input ── */
        .si-inp-wrap { position: relative; display: flex; align-items: center; }
        .si-inp-icon {
          position: absolute; left: 14px;
          color: #94a3b8;
          display: flex; align-items: center; pointer-events: none;
        }
        .si-inp {
          width: 100%;
          padding: 13px 44px 13px 42px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 12px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 15px;
          color: #0f172a;
          outline: none;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none;
        }
        .si-inp::placeholder { color: #cbd5e1; }
        .si-inp:hover { border-color: #cbd5e1; background: #f1f5f9; }
        .si-inp:focus {
          border-color: #2563eb;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
        .si-inp--err {
          border-color: #ef4444 !important;
          background: #fff7f7 !important;
          box-shadow: 0 0 0 3px rgba(239,68,68,0.08) !important;
        }

        /* ── Trigger buttons ── */
        .tfa-trigger-btn {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 600;
          padding: 9px 18px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.18s;
          border: 1.5px solid #bfdbfe;
          background: #eff6ff; color: #1d4ed8;
        }
        .tfa-trigger-btn:hover { background: #dbeafe; border-color: #93c5fd; }
        .tfa-trigger-btn--danger {
          border-color: #fecaca; background: #fff7f7; color: #dc2626;
        }
        .tfa-trigger-btn--danger:hover { background: #fee2e2; border-color: #fca5a5; }

        /* ── Modal shell ── */
        .tfa-modal {
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #ffffff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 24px 80px rgba(0,0,0,0.16), 0 4px 16px rgba(0,0,0,0.08);
          display: flex; flex-direction: column;
          max-height: 92vh;
        }

        /* ── Header ── */
        .tfa-modal-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 22px 28px 20px;
          border-bottom: 1px solid #f1f5f9;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
          flex-shrink: 0;
        }
        .tfa-modal-header-left { display: flex; align-items: center; gap: 14px; }
        .tfa-header-icon {
          width: 44px; height: 44px;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          border: 1.5px solid #bfdbfe;
          border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .tfa-modal-title {
          font-size: 17px; font-weight: 800;
          color: #0f172a; letter-spacing: -0.3px; margin-bottom: 2px;
        }
        .tfa-modal-subtitle { font-size: 12.5px; color: #94a3b8; font-weight: 500; }
        .tfa-close-btn {
          width: 34px; height: 34px;
          background: #f1f5f9; border: none; border-radius: 9px;
          cursor: pointer; display: flex; align-items: center; justify-content: center;
          color: #64748b; transition: all 0.15s; flex-shrink: 0;
        }
        .tfa-close-btn:hover { background: #e2e8f0; color: #0f172a; }

        /* ── Step progress ── */
        .tfa-steps {
          display: flex; align-items: center;
          padding: 16px 28px;
          background: #fafbfc;
          border-bottom: 1px solid #f1f5f9;
          gap: 0;
          flex-shrink: 0;
        }
        .tfa-step {
          display: flex; align-items: center; gap: 8px; flex: 1;
        }
        .tfa-step:last-child { flex: none; }
        .tfa-step-num {
          width: 24px; height: 24px; border-radius: 50%;
          background: #e2e8f0; color: #94a3b8;
          font-size: 11px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .tfa-step-num--active { background: #2563eb; color: #fff; }
        .tfa-step-lbl { font-size: 12px; font-weight: 600; color: #94a3b8; }
        .tfa-step-lbl--active { color: #2563eb; }
        .tfa-step-line { flex: 1; height: 1px; background: #e2e8f0; margin: 0 8px; }

        /* ── Scrollable body ── */
        .tfa-modal-body {
          overflow-y: auto; overflow-x: hidden;
          flex: 1;
          padding: 0 28px;
        }
        .tfa-modal-body::-webkit-scrollbar { width: 4px; }
        .tfa-modal-body::-webkit-scrollbar-track { background: #f8fafc; }
        .tfa-modal-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* ── Sections ── */
        .tfa-section {
          padding: 22px 0;
          border-bottom: 1px solid #f1f5f9;
        }
        .tfa-section--last { border-bottom: none; padding-bottom: 22px; }
        .tfa-section-header {
          display: flex; align-items: center; gap: 10px;
        }
        .tfa-section-num {
          width: 26px; height: 26px; border-radius: 50%;
          background: #f1f5f9; color: #64748b;
          font-size: 12px; font-weight: 700;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .tfa-section-num--active { background: #eff6ff; color: #2563eb; }
        .tfa-section-title { font-size: 14px; font-weight: 700; color: #1e293b; line-height: 25px; }

        /* ── App cards ── */
        .tfa-install-row { display: flex; gap: 10px; margin-bottom: 14px; flex-wrap: wrap; }
        .tfa-app-card {
          display: flex; align-items: center; gap: 10px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 11px;
          padding: 10px 14px; flex: 1; min-width: 160px;
          transition: border-color 0.15s;
        }
        .tfa-app-card:hover { border-color: #93c5fd; }
        .tfa-app-icon {
          width: 36px; height: 36px; border-radius: 9px;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .tfa-app-name { font-size: 13px; font-weight: 700; color: #0f172a; margin-bottom: 2px; }
        .tfa-app-platforms { font-size: 11px; color: #94a3b8; font-weight: 500; }

        .tfa-steps-list {
          list-style: none; padding: 0; margin: 0;
          display: flex; flex-direction: column; gap: 6px;
        }
        .tfa-steps-list li {
          font-size: 13px; color: #475569; line-height: 1.5;
          display: flex; gap: 8px;
          counter-increment: none;
        }
        .tfa-steps-list li::before {
          content: '→'; color: #93c5fd; font-size: 12px; margin-top: 1px; flex-shrink: 0;
        }

        /* ── QR section ── */
        .tfa-qr-wrap {
          display: flex; gap: 20px; align-items: flex-start;
          flex-wrap: wrap;
        }
        .tfa-qr-frame {
          background: #fff; border: 2px solid #e2e8f0; border-radius: 14px;
          padding: 10px; flex-shrink: 0;
          box-shadow: 0 2px 12px rgba(0,0,0,0.06);
        }
        .tfa-qr-img { width: 140px; height: 140px; display: block; }
        .tfa-qr-meta { flex: 1; min-width: 180px; display: flex; flex-direction: column; gap: 12px; }
        .tfa-qr-hint { font-size: 13px; color: #64748b; line-height: 1.55; }

        /* Key rows */
        .tfa-key-row { display: flex; flex-direction: column; gap: 5px; }
        .tfa-key-label {
          font-size: 11.5px; font-weight: 700; color: #374151;
          letter-spacing: 0.3px; text-transform: uppercase;
          display: flex; align-items: center; gap: 6px;
        }
        .tfa-key-badge {
          font-size: 10px; font-weight: 600; text-transform: none;
          background: #fef3c7; color: #92400e;
          border: 1px solid #fde68a; border-radius: 100px;
          padding: 2px 8px; letter-spacing: 0;
        }
        .tfa-key-value-row {
          display: flex; align-items: center; gap: 8px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 9px;
          padding: 8px 12px;
        }
        .tfa-key-code {
          font-family: 'Courier New', monospace;
          font-size: 13px; color: #1e293b; font-weight: 600;
          flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
          letter-spacing: 0.5px;
        }
        .tfa-copy-btn {
          display: inline-flex; align-items: center; gap: 5px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 11.5px; font-weight: 600;
          padding: 5px 10px; border-radius: 7px;
          border: 1.5px solid #e2e8f0; background: #fff;
          color: #64748b; cursor: pointer;
          transition: all 0.15s; flex-shrink: 0;
        }
        .tfa-copy-btn:hover { border-color: #93c5fd; color: #2563eb; background: #eff6ff; }
        .tfa-copy-btn--copied { border-color: #bbf7d0; color: #15803d; background: #f0fdf4; }

        /* ── OTP input row ── */
        .tfa-verify-hint { font-size: 13px; color: #64748b; margin-bottom: 18px; line-height: 1.5; }
        .tfa-otp-row { display: flex; gap: 10px; justify-content: center; margin-bottom: 12px; }
        .tfa-otp-box {
          width: 52px; height: 58px;
          background: #f8fafc;
          border: 1.5px solid #e2e8f0;
          border-radius: 13px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 22px; font-weight: 700;
          color: #0f172a; text-align: center; outline: none;
          transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none; caret-color: #2563eb;
        }
        .tfa-otp-box:focus {
          border-color: #2563eb; background: #fff;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }
        .tfa-otp-box--filled { border-color: #93c5fd; background: #eff6ff; color: #1d4ed8; }
        .tfa-otp-err {
          display: flex; align-items: center; justify-content: center; gap: 5px;
          font-size: 12px; color: #dc2626; font-weight: 500;
        }

        /* ── Footer ── */
        .tfa-modal-footer {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 12px;
          padding: 18px 28px 22px;
          border-top: 1px solid #f1f5f9;
          background: #fafbfc;
          flex-shrink: 0;
        }
        .tfa-security-note {
          display: flex; align-items: center; gap: 6px;
          font-size: 12px; color: #94a3b8; font-weight: 500;
        }
        .tfa-footer-btns { display: flex; align-items: center; gap: 10px; }
        .tfa-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 600;
          padding: 10px 20px; border-radius: 10px;
          border: 1.5px solid #e2e8f0; background: #fff; color: #64748b;
          cursor: pointer; transition: all 0.15s;
        }
        .tfa-btn-cancel:hover { background: #f1f5f9; border-color: #cbd5e1; color: #374151; }
        .tfa-btn-verify {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 22px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(37,99,235,0.3);
          transition: transform 0.15s, box-shadow 0.18s, opacity 0.18s;
          position: relative; overflow: hidden;
        }
        .tfa-btn-verify::after {
          content: '';
          position: absolute; inset: 0;
          background: linear-gradient(135deg, rgba(255,255,255,0.1), transparent 60%);
        }
        .tfa-btn-verify:hover {
          transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(37,99,235,0.38);
        }
        .tfa-btn-verify:active { transform: translateY(0); }
        .tfa-btn-verify:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

        /* Spinner */
        .tfa-spinner {
          display: inline-block; width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.35);
          border-top-color: #fff; border-radius: 50%;
          animation: tfaSpin 0.65s linear infinite;
        }
        @keyframes tfaSpin { to { transform: rotate(360deg); } }

        /* Responsive */
        @media (max-width: 560px) {
          .tfa-modal-header { padding: 18px 20px; }
          .tfa-modal-body { padding: 0 20px; }
          .tfa-modal-footer { padding: 16px 20px 18px; }
          .tfa-steps { padding: 14px 20px; }
          .tfa-qr-wrap { flex-direction: column; align-items: center; }
          .tfa-qr-frame { align-self: center; }
          .tfa-otp-box { width: 44px; height: 52px; font-size: 20px; }
          .tfa-otp-row { gap: 8px; }
          .tfa-footer-btns { width: 100%; justify-content: flex-end; }
          .tfa-security-note { display: none; }
          .tfa-step-lbl { display: none; }
        }

        @media (max-width: 380px) {
          .tfa-otp-box { width: 38px; height: 46px; font-size: 17px; border-radius: 10px; }
          .tfa-otp-row { gap: 6px; }
        }
      `}</style>
    </>
  );
};
export default Recover;
